/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setChosenNameInternal} from '../api'

export const useMutationSetChosenNameInternal = createReactQueryMutationHook('setChosenNameInternal', setChosenNameInternal)
